import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AuthState {
  authToken: string | null
  setAuthToken: (token: string) => void
  removeAuthToken: () => void
}

// !!! Nie je urcene na priamu manipulaciu tokenu !!! Pre manipulaciu tokenu pouzivame ApiClient !!!
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      authToken: null,
      setAuthToken: (token: string) => set({ authToken: token }),
      removeAuthToken: () => set({ authToken: null }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ authToken: state.authToken }), // iba authToken sa persistuje
    }
  )
)
